<template>
  <v-data-table
    :items="products"
    :headers="headers"
    class="table-container"
    item-key="_id"
    hide-actions
    disable-initial-sort
  >
    <template
      slot="items"
      slot-scope="props"
    >
      <tr>
        <td
          :class="{ 'input-highlight': !isProductsInvalid }"
        >
          <v-checkbox
            v-if="showSelect"
            v-model="props.item.selected"
            :input-value="props.item.selected"
            :value="true"
            :value-comparator="() => !!props.item.selected"
            :error="isProductsInvalid"
            @change="selectProduct($event, props.item)"
            color="secondary"
            primary
            hide-details
          />
          {{ props && props.item.description }}
        </td>
        <td>
          <AppInput
            :value="productName(props.item)"
            :class="{ 'input-highlight': !showProductErrorStyle(props.item) }"
            disabled
          />
        </td>
        <td>
          <AppInput
            :value="quantity(props.item)"
            :class="{ 'input-highlight': !showProductErrorStyle(props.item) }"
            disabled
            append-outer="KG"
          />
        </td>
        <td :class="{ 'input-highlight': !isProductsInvalid }">
          <span class="gray--text">
            {{ totalSeedz(props.item) }}
          </span>
        </td>
        <td
          :class="{ 'input-highlight': !isProductsInvalid }"          
          v-if="props.item?.refusalReason?.description"
          style="width: 350px;"
        >
          {{ props.item?.refusalReason?.description }}
        </td>
      </tr>
    </template>
  </v-data-table>
</template>
<script>
import AppInput from '@/components/ui/inputs/AppInput.vue'

export default {
  name: 'ListInvoiceProducts',

  components: {
    AppInput
  },

  props: {
    invoice: {
      type: Object,
      required: true
    },
    showSelect: {
      type: Boolean,
      required: true
    },
    isProductsInvalid: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      products: []
    }
  },

  watch: {
    invoice (value) {
      this.products = value?.products?.map(product => {
        return { ...product, selected: false }
      }) ?? []
    }
  },

  created() {
    if (this.invoice?.products?.length) {
      this.products = this.invoice?.products?.map(product => {
        return { ...product, selected: false }
      })
    }
  },

  computed: {
    headers () {
      const condition = this.invoice?.products?.find(product => product?.refusalReason?._id)
      const reasonColum = condition?._id ? [{
          text: 'Motivo',
          sortable: false,
          value: 'refusalReason'
        }] : []
      const headers = [
        { text: 'Item da nota', value: 'description', sortable: false },
        { text: 'Produto da Campanha', value: 'partnersPremiumProduct', sortable: false },
        { text: 'Quantidade', value: 'invoiceQuantity', sortable: false},
        { text: 'Valor a receber', value: 'totalSeedz', sortable: false},
        ...reasonColum
      ]
      return headers
    },
    isInvoicePending() {
      return this.invoice?.status === 'pending'
    },
    productsSelecteds() {
      return this.products.filter(product => product.selected)
    }
  },

  methods: {
    isProductDonMario(product) {
      return !!product.partnersPremiumProduct
    },

    productName(product) {
      return this.isProductDonMario(product)
        ? product.partnersPremiumName || product.partnersPremiumProduct || '-'
        : 'Não é um produto da campanha'
    },

    totalSeedz(product) {
      if (product.totalSeedz === null || product.totalSeedz === undefined) {
        return '-'
      }
      return product.totalSeedz + ' SDZ'
    },

    quantity(product) {
      return product.partnersPremiumQuantity ?? '-'
    },

    selectProduct(selected, product) {
      product.selected = selected
      this.$emit('select', this.productsSelecteds)
    },

    showProductErrorStyle(product) {
      return this.isProductsInvalid || (this.isProductDonMario(product) && this.isInvoicePending && !product.partnersPremiumName)
    },

    refusalReason(product) {
      return product?.refusalReason?.description
    }
  }
}
</script>
<style lang="stylus" scoped>
.table-container {
  tbody-scroll-width = 10px;

  ::v-deep {
    thead, tbody tr {
      width: 100%;
    }

    tr {
      display: grid;
      grid-template-columns: 350px 200px 150px 140px auto;
      align-items: center;

      td {
        align-items: center;
        display: flex;
        height: 100%;
      }
    }

    tbody {
      max-height: 280px;
      overflow-y: auto;
      overflow-x: hidden;
      display: block;
    }

    .input-highlight {
      color: var(--v-error-base);
      input, span, ::before {
        color: var(--v-error-base) !important;
      }
      input, ::before {
        border-color: var(--v-error-base) !important;
        border-image: none !important;
        border-style: dotted;
        border-width: 0 0 thin 0;
      }

      i {
        margin-bottom: 0;
      }
    }

    @media (min-width: 769px) {
      /* width */
      ::-webkit-scrollbar {
        width: tbody-scroll-width;
        height: tbody-scroll-width;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: #ededed;
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
    }
  }
}
</style>
